import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { firebaseToString } from '../../Tools/tools';
import { child, get, ref, update } from 'firebase/database';
import GlobalContext from '../../Components/GlobalContext';

function ApagarPresenca(props) {

    const { globalData, setGlobalData } = useContext(GlobalContext)

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const removeRoll = () => {
        const logsPath = `rolls/${props.path}/logs`
        let updates = {}
        updates[`rolls/${props.path}/isRollVisible`] = false

        const dbRef = ref(props.db)

        const newLog = {
            datetime: Date.now().toString(),
            descricao: 'Presença deletada',
            usuario: globalData.uid
        }

        get(child(dbRef, logsPath))
            .then((snapshot) => {
                if (snapshot.exists()) {
                    let data = snapshot.val()
                    data.push(newLog)
                    updates[logsPath] = data
                } else {
                    updates[logsPath] = [newLog]
                }
            })
            .then(() => {
                update(dbRef, updates)
            })

        setShow(false)
    }

    let companyName = "";
    let date = "";

    const split = props.path.split("/")
    companyName = firebaseToString(split[1])
    date = split[3]
    date = date.replace('-', '/').replace('-', '/').replace('-', ' ')

    return (
        <>
            <Button variant="danger" className="me-2" onClick={handleShow}>
                <i className="bi bi-trash-fill"></i>
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Excluir Presença</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Você deseja excluir uma presença.<br />
                    Empresa: <b>{companyName}</b><br />
                    Horário: <b>{date}</b>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={removeRoll}>
                        Excluir Presença
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ApagarPresenca